import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-row items-center justify-center"
};
const _hoisted_2 = {
  class: "flex flex-col"
};
const _hoisted_3 = {
  class: "text-base mr-1"
};
const _hoisted_4 = {
  class: "text-xs leading-none"
};
const _hoisted_5 = {
  key: 0,
  class: "mx-1"
};
const _hoisted_6 = {
  class: "mt-4"
};
import { Team } from "@/modules/team/entity/Team";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { PositionEnum } from "@/modules/base/enums";
import LineupFormation from "@/modules/team/components/LineupFormation.vue";
import { Match } from "@/modules/match/entity";
import { Brackets } from "typeorm";
import MatchPanel from "@/modules/diplomacy/components/MatchPanel.vue";
import { onBeforeRouteLeave } from "vue-router";
import StadiumComponent from "@/modules/stadium/components/Stadium.vue";
import { Stadium } from "@/modules/stadium/entity";
import { AIQualityLevelEnum } from "@/modules/ai/enums";
import TeamLogo from "@/modules/team/components/TeamLogo.vue";
import PlayerList from "@/modules/team/components/PlayerList.vue";
import TeamColors from "@/modules/team/components/TeamColors.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const router = useRouter();
    const team = ref();
    const stadium = ref();
    const matches = ref();
    const activeTab = computed(() => route.query.section ?? 'players');
    const aiQualityLevelColors = ref({
      [AIQualityLevelEnum.BEST]: ColorEnum.Green,
      [AIQualityLevelEnum.GOOD]: ColorEnum.Teal,
      [AIQualityLevelEnum.AVERAGE]: ColorEnum.Yellow,
      [AIQualityLevelEnum.BAD]: ColorEnum.Amber,
      [AIQualityLevelEnum.WORST]: ColorEnum.Red
    });
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      team.value = await Team.findOneOrFail({
        where: {
          id: route.params.id
        },
        relations: {
          players: true
        }
      });
      matches.value = await Match.createQueryBuilder('match').innerJoinAndSelect('match.homeTeam', 'homeTeam').innerJoinAndSelect('match.awayTeam', 'awayTeam').innerJoinAndSelect('match.matchday', 'matchday').innerJoinAndSelect('matchday.division', 'division').innerJoinAndSelect('division.competition', 'competition').where(new Brackets(query => {
        query.where('homeTeam.id = :teamId', {
          teamId: team.value.id
        }).orWhere('awayTeam.id = :teamId', {
          teamId: team.value.id
        });
      })).orderBy('matchday.scheduledAt', 'ASC').getMany();
      stadium.value = await Stadium.createQueryBuilder('stadium').innerJoinAndSelect('stadium.terraces', 'terrace').innerJoin('stadium.team', 'team').where('team.id = :id', {
        id: team.value.id
      }).getOneOrFail();
    })), __temp = await __temp, __restore(), __temp);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    const players = computed(() => collect(team.value.players).sortBy(p => Object.values(PositionEnum).indexOf(p.position) * 1000 - p.skill).toArray());
    const onChangeTab = section => {
      // @ts-ignore
      router.replace({
        name: route.name,
        params: route.params,
        query: {
          section
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_NTag = _resolveComponent("NTag");
      const _component_NTabPane = _resolveComponent("NTabPane");
      const _component_NTabs = _resolveComponent("NTabs");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(TeamLogo, {
          team: team.value,
          class: "h-10 w-10 mr-1"
        }, null, 8, ["team"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(team.value.name), 1), _createElementVNode("div", _hoisted_4, "(" + _toDisplayString(team.value.shortName) + ")", 1)]), _ctx.$debug ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_NTag, {
          type: "warning",
          class: "mr-1"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(team.value.aiQualityLevel), 1)]),
          _: 1
        }), _createVNode(_component_NTag, {
          type: "warning"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(team.value.level), 1)]),
          _: 1
        })])) : _createCommentVNode("", true), _createVNode(TeamColors, {
          team: team.value
        }, null, 8, ["team"])])]),
        default: _withCtx(() => [_createVNode(_component_NTabs, {
          "default-value": _unref(activeTab),
          "justify-content": "space-evenly",
          type: "line",
          "on-update:value": onChangeTab
        }, {
          default: _withCtx(() => [_createVNode(_component_NTabPane, {
            tab: _ctx.$t('players'),
            name: "players",
            "display-directive": "show:lazy"
          }, {
            default: _withCtx(() => [_createVNode(PlayerList, {
              players: _unref(players),
              "show-talent": "",
              "show-market-value": ""
            }, null, 8, ["players"])]),
            _: 1
          }, 8, ["tab"]), _createVNode(_component_NTabPane, {
            tab: _ctx.$t('lineup'),
            name: "lineup",
            "display-directive": "show:lazy"
          }, {
            default: _withCtx(() => [_createVNode(LineupFormation, {
              class: "mt-4",
              team: team.value
            }, null, 8, ["team"])]),
            _: 1
          }, 8, ["tab"]), _createVNode(_component_NTabPane, {
            tab: _ctx.$t('matches'),
            name: "matches",
            "display-directive": "show:lazy"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matches.value, match => {
              return _openBlock(), _createBlock(MatchPanel, {
                key: match,
                match: match
              }, null, 8, ["match"]);
            }), 128))])]),
            _: 1
          }, 8, ["tab"]), _createVNode(_component_NTabPane, {
            tab: _ctx.$t('stadium'),
            name: "stadium",
            "display-directive": "show:lazy"
          }, {
            default: _withCtx(() => [_createVNode(StadiumComponent, {
              class: "mt-4",
              stadium: stadium.value
            }, null, 8, ["stadium"])]),
            _: 1
          }, 8, ["tab"])]),
          _: 1
        }, 8, ["default-value"])]),
        _: 1
      });
    };
  }
});